
































import { Component, Prop, Mixins } from "vue-property-decorator";

// types
import { ICurrency } from "@/models/constants";
import CurrenciesStore from "@/mixins/constants/currenciesStore";

// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export enum CURRENCY_LABEL {
  CODE_AND_NAME = "code-and-name",
  CODE = "code",
  NAME = "name"
}

export enum CURRENCY_VALUE {
  OBJECT = "object",
  CODE = "code",
  ID = "id"
}

@Component({
  components: {
    Treeselect
  }
})
export default class CurrencySelect extends Mixins(CurrenciesStore) {
  // Props
  @Prop({ required: true })
  public value!: string | number | ICurrency;

  @Prop({ default: () => [] })
  public currencyOptions!: ICurrency[];

  @Prop({ default: () => [] })
  public currencyCodes!: string[];

  @Prop({ default: () => [] })
  public currencyIds!: ICurrency["id"][];

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: true })
  public showFlagInValue!: boolean;

  @Prop({ default: true })
  public showFlagInOptions!: boolean;

  @Prop({ default: true })
  public clearable!: boolean;

  @Prop({ default: false })
  public expanded!: boolean;

  @Prop({ default: false })
  public alwaysOpen!: boolean;

  @Prop({ default: false })
  public autoFocus!: boolean;

  @Prop({ default: CURRENCY_LABEL.CODE_AND_NAME })
  public labelType!: CURRENCY_LABEL;

  @Prop({ default: CURRENCY_VALUE.ID })
  public valueType!: CURRENCY_VALUE;

  public get options() {
    let currencies: ICurrency[] = [];

    if (this.currencyOptions.length) {
      currencies = this.currencyOptions;
    } else {
      if (!this.currenciesLoaded) {
        return [];
      }
      if (this.currencyOptions.length) {
        currencies = this.currencyOptions;
      } else if (this.currencyCodes.length) {
        currencies = this.currencies.filter(c =>
          this.currencyCodes.includes(c.code)
        );
      } else if (this.currencyIds.length) {
        currencies = this.currencies.filter(c =>
          this.currencyIds.includes(c.id)
        );
      } else {
        currencies = this.currencies;
      }
    }

    currencies = this.$_.cloneDeep(currencies);
    return currencies.map(currency => {
      return {
        label: this.getOptionLabel(currency),
        ...currency
      };
    });
  }

  public handleInput(currencyId: ICurrency["id"]) {
    const currency = this.options.find(c => c.id === currencyId);
    if (currency === undefined) {
      return this.$emit("input", null);
    }
    if (this.valueType === CURRENCY_VALUE.ID) {
      return this.$emit("input", currency.id);
    }
    if (this.valueType === CURRENCY_VALUE.CODE) {
      return this.$emit("input", currency.code);
    }
    return this.$emit("input", currency);
  }

  public get valueFormatted() {
    if (!this.$_.isNumber(this.value) && this.$_.isEmpty(this.value)) {
      return null;
    }
    let currency: ICurrency | undefined = {} as ICurrency;
    if (this.valueType === CURRENCY_VALUE.ID) {
      currency = this.options.find(c => c.id === this.value);
    } else if (this.valueType === CURRENCY_VALUE.CODE) {
      currency = this.options.find(c => c.code === this.value);
    } else if (this.valueType === CURRENCY_VALUE.OBJECT) {
      currency = this.options.find(c => c.id === (this.value as ICurrency).id);
    }

    return currency ? currency.id : null;
  }

  public getOptionLabel(currency: ICurrency) {
    if (this.labelType === CURRENCY_LABEL.CODE_AND_NAME) {
      return `<span class="has-text-grey-light">${currency.code}</span> - ${currency.name}`;
    }
    if (this.labelType === CURRENCY_LABEL.CODE) {
      return currency.code;
    }
    return currency.name;
  }
}
